import { render, staticRenderFns } from "./CommonDocsTypeModal.vue?vue&type=template&id=0126eb4c&"
import script from "./CommonDocsTypeModal.vue?vue&type=script&lang=js&"
export * from "./CommonDocsTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports